/* @flow */
import React from 'react';
import Activity from 'entities/Activity';
import ActivityListMiniItem from 'payments/components/ActivityListMiniItem.jsx';

import './styles/ActivityListCard.scss';

type Props = {
  activities: Activity[],
  title: string,
};

class ActivityListCard extends React.Component {
  props: Props;

  render() {
    return (
      <div className="ActivityListCard">
        <div className="ActivityListCard-title">
          {this.props.title}
        </div>
        {this.props.activities.map(activity =>
          <div key={activity.id} className="ActivityListCard-item">
            <ActivityListMiniItem activity={activity} />
          </div>
        )}
      </div>
    );
  }
}

export default ActivityListCard;



// WEBPACK FOOTER //
// ./src/payments/components/ActivityListCard.jsx